export { default } from './Badge';
export type { BadgeVariant } from './Badge';
